import { Module } from './common'

/**
 * Base preprocessing module - transforms input point cloud
 */
export abstract class Preprocessing extends Module {
  /**
   * Process input points and return transformed points
   * @param points - Input point cloud as interleaved Float32Array [x,y,z,x,y,z,...]
   * @returns Transformed point cloud
   */
  abstract run(points: Float32Array): Float32Array

  /**
   * Get a human-readable name for this preprocessing step
   */
  abstract getName(): string
}
